// authenticate/createAccountListeners.ts

/**
 * Attaches event listeners to the account details form.
 * Toggles the Virgin Red number input visibility based on the VR checkbox
 * and focuses the input after the toggle animation completes.
 *
 * @returns {void}
 */
export function createAccountListeners(): void {
	const accountDetailsForm = document.querySelector('#accountDetailsForm') as HTMLFormElement;
	if (!accountDetailsForm) return;

	accountDetailsForm.addEventListener('submit', () => {
		const submitBtn = accountDetailsForm.querySelector(
			'button[type="submit"]',
		) as HTMLButtonElement;
		submitBtn?.classList.add('btn-loading');
	});

	// Virgin Red inputs handling (core registration)
	const vrCheckbox = accountDetailsForm.querySelector(
		'input[name="haveVR"]',
	) as HTMLInputElement | null;
	if (vrCheckbox) {
		const vrTextInputWrapper = accountDetailsForm.querySelector(
			'.virgin-members__input-wrapper',
		) as HTMLElement | null;
		const vrTextInput = accountDetailsForm.querySelector(
			'input[name="virginRedNumber"]',
		) as HTMLInputElement | null;
		if (!vrTextInputWrapper) return;
		vrCheckbox.addEventListener('change', function () {
			vrTextInputWrapper.classList.toggle('hidden');
			vrTextInputWrapper.addEventListener(
				'transitionend',
				() => {
					if (vrTextInput) {
						vrTextInput.setAttribute('tabindex', '0');
						vrTextInput.focus();
					}
				},
				{ once: true },
			);
		});

		if (vrCheckbox.checked) {
			vrTextInputWrapper.classList.toggle('hidden');
		}
	}
}
